import { getActiveInstance } from './ghlInstance'

const RECONNECT_BASE_MS = 1000
const RECONNECT_MAX_MS = 30000

function resolveWsBaseUrl() {
  const configured = process.env.VUE_APP_GHL_WS_URL
  if (configured) {
    return String(configured).replace(/\/$/, '')
  }

  const analyticsApi = process.env.VUE_APP_ANALYTICS_API || ''
  if (analyticsApi) {
    try {
      const url = new URL(analyticsApi)
      url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
      url.pathname = '/api/v1/ghl/ai/ws'
      url.search = ''
      url.hash = ''
      return url.toString().replace(/\/$/, '')
    } catch (_err) {
      // fall through
    }
  }

  return 'ws://localhost:3003/api/v1/ghl/ai/ws'
}

function buildWsUrl() {
  const token = localStorage.getItem('ecmtctoken')
  const usid = getActiveInstance() || localStorage.getItem('ec_current_usid') || ''
  const base = resolveWsBaseUrl()
  const params = new URLSearchParams()
  if (token) {
    params.set('token', token)
  }
  if (usid) {
    params.set('usid', usid)
  }
  const query = params.toString()
  return query ? `${base}?${query}` : base
}

export function createInboxSocket(handlers = {}) {
  let socket = null
  let reconnectTimer = null
  let reconnectAttempts = 0
  let closedByUser = false

  const connect = () => {
    if (closedByUser) {
      return
    }

    const url = buildWsUrl()
    socket = new WebSocket(url)

    socket.addEventListener('open', () => {
      reconnectAttempts = 0
      if (typeof handlers.onOpen === 'function') {
        handlers.onOpen()
      }
    })

    socket.addEventListener('message', (event) => {
      try {
        const payload = JSON.parse(event.data)
        if (payload && payload.type === 'connected') {
          if (typeof handlers.onConnect === 'function') {
            handlers.onConnect(payload)
          }
          return
        }
        if (typeof handlers.onMessage === 'function') {
          handlers.onMessage(payload)
        }
      } catch (_err) {
        // ignore malformed payloads
      }
    })

    socket.addEventListener('close', () => {
      if (typeof handlers.onDisconnect === 'function') {
        handlers.onDisconnect()
      }
      if (closedByUser) {
        return
      }
      const delay = Math.min(
        RECONNECT_MAX_MS,
        RECONNECT_BASE_MS * Math.pow(2, reconnectAttempts)
      )
      reconnectAttempts += 1
      reconnectTimer = window.setTimeout(connect, delay)
    })

    socket.addEventListener('error', () => {
      if (typeof handlers.onError === 'function') {
        handlers.onError()
      }
    })
  }

  connect()

  return {
    close() {
      closedByUser = true
      if (reconnectTimer) {
        window.clearTimeout(reconnectTimer)
        reconnectTimer = null
      }
      if (socket) {
        socket.close()
        socket = null
      }
    }
  }
}
